import Delete16 from '@carbon/icons-react/es/delete/16';
import DocumentBlank16 from '@carbon/icons-react/es/document--blank/16';
import SailboatOffshore16 from '@carbon/icons-react/es/sailboat--offshore/16';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TimeoffCreated, TimeoffDeleted } from 'api/notifications/meta';
import { humanise } from 'components/atoms/humanised-date';
import { ApprovalComment } from './approval-comment';
import { Causer } from './causer';

const Flex = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DeleteIcon = styled(Flex)`
  svg {
    color: var(--red-50);
  }
`;

const TimeOffIcon = styled(Flex)`
  svg {
    color: var(--purple-60);
  }
`;

const getDateRange = (timeOffEnd, timeOffStart) => {
  if (moment(timeOffEnd).isSame(timeOffStart, 'day')) {
    return humanise(moment(timeOffStart));
  }

  return `${humanise(moment(timeOffStart))} - ${humanise(moment(timeOffEnd))}`;
};

export const TimeoffNote: FC<{ meta: TimeoffCreated }> = ({
  meta: { note },
}) => {
  if (note) {
    return (
      <ApprovalComment
        content={note}
        icon={<DocumentBlank16 />}
        background="var(--coolest-gray-10)"
      />
    );
  }

  return null;
};

export const TimeoffCreatedView: FC<{
  meta: TimeoffCreated;
}> = ({ meta: { by, timeOffEnd, timeOffStart } }) => (
  <FormattedMessage
    id="notifications.messages.timeoff_created"
    values={{
      causer: <Causer user={by} />,
      icon: (
        <TimeOffIcon>
          <SailboatOffshore16 />
        </TimeOffIcon>
      ),
      dates: getDateRange(timeOffEnd, timeOffStart),
      strong: (chunks) => <strong>{chunks}</strong>,
    }}
  />
);

export const TimeoffDeletedView: FC<{
  meta: TimeoffDeleted;
}> = ({ meta: { by, timeOffEnd, timeOffStart } }) => (
  <FormattedMessage
    id="notifications.messages.timeoff_deleted"
    values={{
      causer: <Causer user={by} />,
      icon: (
        <DeleteIcon>
          <Delete16 />
        </DeleteIcon>
      ),
      dates: getDateRange(timeOffEnd, timeOffStart),
      strong: (chunks) => <strong>{chunks}</strong>,
    }}
  />
);
